const buildLinesFromArray = (data, operation, addData) => {
    const sourceItems = addData[operation.sourceArray] ?? []
    data[operation.targetArray] = sourceItems.map(item => {
        const line = {}
        for (const f of operation.fieldMap) {
            if (f.toValue !== undefined)  line[f.targetField] = f.toValue
            else if (f.fromParent)        line[f.targetField] = addData[f.sourceField]
            else                          line[f.targetField] = item[f.sourceField]
        }
        return line
    })
    return data
}

export default buildLinesFromArray
